<mat-card class="product-card">
  <ng-container *ngIf="!product1">
    <mat-card-header>
      <mat-card-title i18n="@@No Product">No Product</mat-card-title>
    </mat-card-header>
  </ng-container>
  <ng-container *ngIf="product1">
    <mat-card-content>
      <div>
        <form [formGroup]="productForm">
          <table class="propertiesTable">
            <tr class="propertyRow">
              <td class="name" i18n="@@Property">Property</td>
              <td class="value"><span *ngIf="product1">{{heading1}}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode">
                  <span *ngIf="product2">{{heading2}}</span>
                  <span> </span>
                  <button *ngIf="isEditingAnOption && !isEditMode && product2" mat-flat-button color="primary" (click)="toggleEditMode()">
                    <mat-icon>edit</mat-icon>
                    <span i18n="@@editListingButton">Edit Listing</span>
                </button>
                </ng-container>
                <ng-container *ngIf="isEditMode"><span *ngIf="product2">{{heading2}}</span></ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Title">Title</td>
              <td class="value"><span *ngIf="product1.title">{{ product1.title }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.title">{{ product2?.title }}</span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@titleLabel">Title</mat-label>
                    <input matInput formControlName="title" required>
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Sub Title">Sub Title</td>
              <td class="value"><span *ngIf="product1.subtitle">{{ product1.subtitle }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.subtitle">{{ product2?.subtitle }}</span></ng-container>
                <ng-container *ngIf="isEditMode"></ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Description">Description</td>
              <td class="value"><span *ngIf="product1.description" [innerHTML]="product1.description"></span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.description" [innerHTML]="product2?.description"></span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <div class="full-width rich-text-editor-container">
                    <mat-label i18n="@@descriptionLabel">Description (Rich Text)</mat-label>
                    <ng-container *ngIf="isEditMode; else displayDescription">
                      <quill-editor
                        [formControlName]="'description'"
                        [styles]="{'height': '200px'}"
                        [modules]="quillConfig"
                        i18n-placeholder="@@rtePlaceholder"
                        placeholder="Start writing the product description here..."
                        (onEditorCreated)="onEditorCreated($event)"></quill-editor>
                    </ng-container>
                    <ng-template #displayDescription>
                      <div class="description-display" [innerHTML]="productForm.get('description')?.value"></div>
                    </ng-template>
                    <mat-hint *ngIf="isEditMode" i18n="@@htmlFragmentHint">Data is saved as an HTML fragment.</mat-hint>
                    <mat-hint *ngIf="!isEditMode && productForm.get('description')?.value" i18n="@@displayHtmlHint">Displaying HTML fragment below.</mat-hint>
                  </div>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Short Description">Short Description</td>
              <td class="value"><span *ngIf="product1.shortDescription">{{ product1.shortDescription }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.shortDescription">{{ product2?.shortDescription }}</span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label i18n="@@shortDescriptionLabel">Short Description</mat-label>
                    <textarea matInput formControlName="shortDescription" rows="2"></textarea>
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Customer Product IdSKU">Customer Product Id / SKU</td>
              <td class="value"><span *ngIf="product1.customerProduct_ID">{{ product1.customerProduct_ID }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.customerProduct_ID">{{ product2?.customerProduct_ID }}</span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@customerProductIdLabel">Customer Product Id</mat-label>
                    <input matInput formControlName="customerProduct_ID">
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@ISBN">ISBN</td>
              <td class="value"><span *ngIf="product1.EAN13">{{ product1.EAN13 }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.EAN13">{{ product2?.EAN13 }}</span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@isbnLabel">ISBN (EAN13)</mat-label>
                    <input matInput formControlName="EAN13" required>
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Author">Author</td>
              <td class="value"><span *ngIf="product1.productAuthor">{{ product1.productAuthor }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.productAuthor">{{ product2?.productAuthor }}</span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@authorLabel">Author</mat-label>
                    <input matInput formControlName="productAuthor">
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Publication Year">Publication Year</td>
              <td class="value"><span *ngIf="product1.productPublicationYear">{{ product1.productPublicationYear }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.productPublicationYear">{{ product2?.productPublicationYear }}</span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@publicationYearLabel">Publication Year</mat-label>
                    <input matInput type="number" formControlName="productPublicationYear">
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Language">Language</td>
              <td class="value"><span *ngIf="product1.languageCode">{{ product1.languageCode }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.languageCode">{{ product2?.languageCode }}</span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@languageCodeLabel">Language Code</mat-label>
                    <input matInput
                           formControlName="languageCode"
                           [matAutocomplete]="langAuto"
                           i18n-placeholder="@@Language"
                           placeholder="Language">
                    <mat-autocomplete #langAuto="matAutocomplete">
                      <mat-option *ngFor="let lang of filteredLanguages$ | async" [value]="lang.iso639_3">
                        {{ languageDisplayName(lang) }}
                        <span class="lang-code-hint">({{ lang.iso639_3 }}<span *ngIf="lang.iso639_2">, {{ lang.iso639_2 }}</span>)</span>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Preview Pages">Preview Pages</td>
              <td class="value"><span *ngIf="product1.previewPages">{{ product1.previewPages }}</span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.previewPages">{{ product2?.previewPages }}</span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label i18n="@@previewPagesLabel">Preview Pages (Comma Separated)</mat-label>
                    <input matInput formControlName="previewPages">
                    <mat-hint i18n="@@previewPagesHint">e.g., 1,5,10,24</mat-hint>
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@MSRP">MSRP</td>
              <td class="value"><span *ngIf="product1.msrp">{{ product1.msrp | number:'1.1-2'  }}&nbsp;<span>{{ product1.msrpCurrency || 'USD' }}</span></span></td>
              <td class="value">
                <ng-container *ngIf="!isEditMode"><span *ngIf="product2?.msrp">{{ product2?.msrp | number:'1.1-2'  }}&nbsp;<span>{{ product2?.msrpCurrency || 'USD' }}</span></span></ng-container>
                <ng-container *ngIf="isEditMode">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@msrpLabel">MSRP</mat-label>
                    <input matInput type="number" formControlName="msrp" required (blur)="formatMSRP($event)">
                    <span matTextPrefix i18n="@@currencySymbol">$</span>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@currencyLabel">Currency</mat-label>
                    <mat-select formControlName="msrpCurrency" required>
                      <mat-option value="USD" i18n="@@usdOption">Dollars (USD)</mat-option>
<!--                      <mat-option value="EUR" i18n="@@eurOption">Euros (EUR)</mat-option>-->
<!--                      <mat-option value="GBP" i18n="@@gbpOption">Pounds (GBP)</mat-option>-->
                    </mat-select>
                  </mat-form-field>
                </ng-container>
              </td>
            </tr>
            <!-- non-editable properties -->
            <tr class="propertyRow">
              <td class="name" i18n="@@Height">Height</td>
              <td class="value"><span *ngIf="product1.productHeight">{{ product1.productHeight / 72.0 | number:'1.1-2' }}<span i18n="@@in">in</span></span></td>
              <td class="value"><span *ngIf="product2?.productHeight">{{ product2?.productHeight / 72.0 | number:'1.1-2' }}<span i18n="@@in">in</span></span></td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Height">Height</td>
              <td class="value"><span *ngIf="product1.productWidth">{{ product1.productWidth / 72.0 | number:'1.1-2' }}<span i18n="@@in">in</span></span></td>
              <td class="value"><span *ngIf="product2?.productWidth">{{ product2?.productWidth / 72.0 | number:'1.1-2' }}<span i18n="@@in">in</span></span></td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Weight">Weight</td>
              <td class="value"><span *ngIf="product1.productWeight">{{ product1.productWeight | number:'1.1-2' }}<span i18n="pounds, unit of weight|Abbreviation for pounds (weight), rendered immediately after a number with no space, e.g. '2.50lbs'. Must be a short unit abbreviation. In French especially, do not spell it 'livres' - that is the word for books and it also reads as prose in a numeric cell.@@lbs">lbs</span></span></td>
              <td class="value"><span *ngIf="product2?.productWeight">{{ product2?.productWeight | number:'1.1-2' }}<span i18n="pounds, unit of weight|Abbreviation for pounds (weight), rendered immediately after a number with no space, e.g. '2.50lbs'. Must be a short unit abbreviation. In French especially, do not spell it 'livres' - that is the word for books and it also reads as prose in a numeric cell.@@lbs">lbs</span></span></td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Total Pages">Total Pages</td>
              <td class="value"><span *ngIf="product1.productNumPages">{{ product1.productNumPages }}</span></td>
              <td class="value"><span *ngIf="product2?.productNumPages">{{ product2?.productNumPages }}</span></td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Binding">Binding</td>
              <td class="value"><span *ngIf="product1.productBindingType">{{ product1.productBindingType }}</span></td>
              <td class="value"><span *ngIf="product2?.productBindingType">{{ product2?.productBindingType }}</span></td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Color or BlackWhite">Color or Black/White</td>
              <td class="value"><span *ngIf="product1.productInteriorType">{{ product1.productInteriorType }}</span></td>
              <td class="value"><span *ngIf="product2?.productInteriorType">{{ product2?.productInteriorType }}</span></td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Book Id">Book Id</td>
              <td class="value"><span *ngIf="product1.book_ID">{{ product1.book_ID }}</span></td>
              <td class="value"><span *ngIf="product2?.book_ID">{{ product2?.book_ID }}</span></td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Created Date">Created Date</td>
              <td class="value"><span *ngIf="product1.created">{{ product1.created | date: 'MM/dd/yy hh:mm:ss' }}</span></td>
              <td class="value"><span *ngIf="product2?.created">{{ product2?.created | date: 'MM/dd/yy hh:mm:ss' }}</span></td>
            </tr>
            <tr class="propertyRow">
              <td class="name" i18n="@@Updated">Updated</td>
              <td class="value"><span *ngIf="product1.updateTimestamp">{{ product1.updateTimestamp | date: 'MM/dd/yy hh:mm:ss' }}</span></td>
              <td class="value"><span *ngIf="product2?.updateTimestamp">{{ product2?.updateTimestamp | date: 'MM/dd/yy hh:mm:ss' }}</span></td>
            </tr>
          </table>
          <mat-card-actions *ngIf="isEditMode" align="end">
            <button mat-button type="button" (click)="onCancel()" i18n="@@cancelButton">Cancel</button>
            <button mat-flat-button color="accent" type="submit" (click)="onSave()" [disabled]="productForm.invalid || productForm.pristine"><mat-icon>save</mat-icon><span i18n="@@saveButton">Save</span></button>
          </mat-card-actions>
        </form>
      </div>
    </mat-card-content>
  </ng-container>
</mat-card>
